<template>
  <div class="d-flex flex-wrap align-items-end mb-2" style="gap: 12px">
    <b-form-group label="แพทย์" label-for="nhso-doctor" label-size="sm" label-class="field-lbl" class="mb-0" style="min-width: 220px">
      <b-form-select
        id="nhso-doctor"
        :value="value.doctor"
        :options="doctors"
        size="sm"
        @change="update({ doctor: $event })"
      >
        <template #first>
          <b-form-select-option :value="null">แพทย์ทั้งหมด</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-form-group label="รายการรักษา" label-size="sm" label-class="field-lbl" class="mb-0" style="flex: 1 1 320px; min-width: 0">
      <b-input-group>
        <multiselect
          class="col p-0 multiselect-h-36px"
          :value="selectedTx"
          :options="getGroupedTreatListNhso"
          :limit="5"
          :multiple="true"
          :close-on-select="false"
          group-values="libs"
          group-label="category"
          :group-select="true"
          placeholder="ค้นหาการรักษาที่ต้องการกรอง"
          :custom-label="txLabel"
          track-by="nameTh"
          selectLabel
          selectedLabel
          deselectLabel
          @input="setTx"
        >
          <template #option="props">
            <span v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
          </template>
          <span slot="noResult">ไม่พบรายการ กรุณาเปลี่ยนคำค้นหา</span>
        </multiselect>
        <b-input-group-append>
          <b-button size="sm" variant="outline-warning" aria-label="บันทึกตัวกรองนี้" @click="$refs.nameInput.openModal()">
            <i class="far fa-star"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group label="ตัวกรองที่บันทึก" label-size="sm" label-class="field-lbl" class="mb-0" style="flex: 1 1 260px; min-width: 0">
      <!-- same storage as the old รายงาน สปสช. tab, so saved filters carry over -->
      <FavFilter ref="favFilter" storage-name="favouriteFilter" :height="36" @listClicked="applySaved" />
    </b-form-group>
    <NameInput ref="nameInput" @submitName="saveFav" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FavFilter from "@/components/FavFilter";
import NameInput from "@/components/modal/NameInput";

export default {
  name: "NhsoVisitFilters",
  components: { FavFilter, NameInput },
  props: {
    // { doctor: string|null, txIds: number[] } — see filterNhsoVisits in utils/reconciliation
    value: { type: Object, required: true },
    doctors: { type: Array, default: () => [] },
  },
  data() {
    return { selectedTx: [] };
  },
  computed: {
    ...mapGetters({ getGroupedTreatListNhso: "moduleAppointment/getGroupedTreatListNhso" }),
  },
  methods: {
    update(patch) {
      this.$emit("input", { ...this.value, ...patch });
    },
    setTx(list) {
      this.selectedTx = list || [];
      this.update({ txIds: this.selectedTx.map((t) => t.id) });
    },
    txLabel(option) {
      const code = option.code ? `[${option.code}]-` : "";
      return option.nameEn && option.nameEn !== option.nameTh ? `${code}${option.nameTh} / ${option.nameEn}` : `${code}${option.nameTh}`;
    },
    applySaved({ selectedTx }) {
      this.setTx((selectedTx || []).flat());
    },
    saveFav(text) {
      this.$refs.favFilter.addItem({ text, selectedTx: this.selectedTx, selectedDrug: [] });
    },
  },
};
</script>
